import type { ProductFavorite } from "@prisma/client"

export class ProductFavoriteModel {
  table = 'productFavorite'
}

export type ProductFavoriteType = ProductFavorite & {
}